import type { ClosedReason } from '@prerender/diagnostics-api';
import { Alert } from 'react-bootstrap';

import { closedReasonLabel } from './closedReasonLabels';
import { incidentStatusLabel } from './incidentStatusLabels';

type ClosedBannerProps = {
  closedReason: ClosedReason | null;
};

function ClosedBanner({ closedReason }: ClosedBannerProps) {
  return (
    <Alert variant="info" role="status" className="diagnostics-detail-closure">
      <span className="diagnostics-detail-closure-verdict">
        {closedReason === null ? incidentStatusLabel('closed') : closedReasonLabel(closedReason)}
      </span>
    </Alert>
  );
}

export default ClosedBanner;
